module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-add-789df3786bcbad9b3b39d198d771b2b1.png";